export default __webpack_public_path__ + "static/media/homeBasketball.796896b2.jpg";